export default __webpack_public_path__ + "static/media/HUD-Effects-HUD Electrical Distortion.2fc1de4d.jpg";